import { useEffect, useRef } from 'react';
export const usePreventMultiClick = fn => {
  const isProcessing = useRef(false);
  const timerId = useRef(null);
  const preventMultiClick = async function () {
    if (isProcessing !== null && isProcessing !== void 0 && isProcessing.current) return;
    isProcessing.current = true;
    timerId.current = setTimeout(() => {
      isProcessing.current = false;
    }, 3000);
    return await fn(...arguments);
  };
  useEffect(() => {
    return () => {
      if (timerId !== null && timerId !== void 0 && timerId.current) {
        clearTimeout(timerId.current);
      }
    };
  }, []);
  const stopProcessing = () => {
    if (timerId !== null && timerId !== void 0 && timerId.current) {
      clearTimeout(timerId.current);
    }
    isProcessing.current = false;
  };
  return {
    preventMultiClick,
    isProcessing: isProcessing.current,
    stopProcessing
  };
};